// extracted by mini-css-extract-plugin
export default {"carousel":"RoomCarousel_carousel__UYJbu","disabled":"RoomCarousel_disabled__JK+Ky"};